<template>

    <div class="dd-l-grid dd-l-grid--category-products dd-l-grid--category-products-custom">
        <div class="dd-l-grid--category-products__container">

            <div v-if="isLoadingFirst" class="dd-m-text-center">
                <loading></loading>
            </div>

            <div v-if="results.length" class="dd-l-grid--category-products__content">
                <div class="dd-l-grid--category-products__list">
                    <card-custom-category-product v-for="(item, index) in results"
                        :item="item"
                        :key="index"></card-custom-category-product>
                </div>

                <div class="dd-l-grid--category-products__bottom">
                    <vue-ladda button-class="dd-m-button dd-m-button--auto dd-m-button--light"
                               v-if="hasMore"
                               :loading="isLoadingMore"
                               v-on:click.prevent="loadMore()">
                        {{getTranslateString('View More')}}
                    </vue-ladda>
                </div>

                <div class="dd-m-alert dd-m-alert--danger dd-m-m-t-12" v-if="errors.length">
                    <span v-for="(item, index) in errors" :key="index">
                        {{item}}
                    </span>
                </div>
            </div>

            <div class="dd-m-extra--section-description"
                 v-if="isEmpty">
                {{getTranslateString("No products were found in the category.")}}
            </div>
        </div>
    </div>

</template> 
<script>
    import Q from 'q';
    import ProductService from "../../providers/api/product-service";
    import Loading from "../loading";
    import CardCustomCategoryProduct from "./card-custom-category-product";

    const productService = new ProductService();

    export default {
        name: 'list-products-by-category',
        components: {CardCustomCategoryProduct, Loading},
        props: ['perPage', 'cat'],
        data: () => {
            return {
                results: [],
                page: 1,
                hasMore: false,
                isLoadingFirst: false,
                isLoadingMore: false,
                errors: [],
                isEmpty: false
            }
        },
        mounted() {
            this.getProducts(true);
        },
        methods: {
            getProducts(isLoadingFirst = false) {
                const d = Q.defer(),
                    params = {
                        perPage: this.perPage,
                        page: this.page,
                        categories: this.cat
                    };

                this.isLoadingFirst = isLoadingFirst;

                productService.doGetProducts(params)
                    .then((res) => {
                        res.data.data.map((item) => this.results.push(item));
                        this.hasMore = res.data.pagination.links.next;
                        this.isEmpty = !this.results.length && params.page === 1;
                        this.isLoadingFirst = false;
                        d.resolve();
                    })
                    .catch(() => {
                        this.isLoadingFirst = false;
                        d.resolve();
                    });

                return d.promise;
            },
            loadMore() {
                this.page++;
                this.isLoadingMore = true;
                this.getProducts().then(() => this.isLoadingMore = false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/list-products-by-category.vue